import React from 'react';
import {
    SwitchView,
    CloseStream,
    StreamLoader,
    StreamButtonsWrapperATR,
    RacingStreamWrapperATR,
    StreamWrapperATR,
} from 'src/domains/sportsbook/webview/components/stream/RacingStream.style';
import ReactPlayer from 'react-player';
import { Spinner } from 'src/domains/layouts/shared/assets/icons/Spinner';
import { observer } from 'src/utils/mobx-react';
import { AppLayoutsState } from 'src/domains/layouts/state/AppLayouts.state';
import { useCommon } from 'src/domains/common/Common';
import { StreamingState } from 'src/domains/sportsbook/state/streamingState/StreamingState';

export interface RacingStreamPropsTypes {
    isNotificationsList: boolean;
}

export const RacingStream = observer('RacingStream', ({ isNotificationsList }: RacingStreamPropsTypes) => {
    const common = useCommon();
    const appLayoutsState = AppLayoutsState.get(common);

    const { bannersBoxState, notificationsState } = appLayoutsState;
    const streamingState = StreamingState.get(common);

    if (streamingState.openEventId === null) {
        return null;
    }

    const streamEvent = streamingState.getModel(streamingState.openEventId);

    const providerName = streamingState.providerName;
    const streamUrl = streamEvent.streamUrl;
    const isOpen = streamingState.isStreamOpen;
    const boxHeight = streamingState.boxHeightHeightRmgRestrictions;

    const getStreamUrl = streamUrl?.type === 'ready' ? streamUrl.url : '';
    if (getStreamUrl === null) {
        return null;
    }

    if (streamUrl?.type === 'loading') {
        return (
            <StreamLoader>
                <Spinner />
            </StreamLoader>
        );
    }

    const renderButtons = (
        <StreamButtonsWrapperATR
            isFloating={streamingState.isStreamFloating}
            isOpen={isOpen}
            provider={providerName}
        >
            <SwitchView
                position='down'
                isFloating={streamingState.isStreamFloating}
                isOpen={isOpen}
                onClick={streamingState.switchFloatingStream}
                provider={providerName}
            />
            <CloseStream
                isFloating={streamingState.isStreamFloating}
                isOpen={isOpen}
                onClick={streamingState.closeStream}
                provider={providerName}
            />
        </StreamButtonsWrapperATR>
    );

    return (
        <RacingStreamWrapperATR
            isFloating={streamingState.isStreamFloating}
            isOpen={isOpen}
        >
            {streamingState.isStreamFloating ? '' : renderButtons}

            <StreamWrapperATR
                // isNotificationAvailable={notificationsState.notifications}
                isNotificationAvailable={isNotificationsList === true ? notificationsState.notifications : []}
                bannersHeight={bannersBoxState.boxHeight}
                height={boxHeight}
                isOpen={isOpen}
                isFloating={streamingState.isStreamFloating}
                ref={streamingState.setIframeRef}
            >
                {streamingState.isStreamFloating ? renderButtons : ''}

                <ReactPlayer
                    style={{ display: 'flex' }}
                    src={getStreamUrl}
                    width='100%'
                    height='100%'
                    playsInline={true}
                    controls={true}
                    controlsList='nofullscreen'
                    onError={(e) => {
                        console.error('ReactPlayer HLS Error:', e);
                    }}
                />
            </StreamWrapperATR>
        </RacingStreamWrapperATR>
    );
});
